export const reviewApi = {
  createReview: (): string => `/api/public/reviews`,
  updateReview: (reviewId: string): string => `/api/admin/reviews/${reviewId}`,
  deleteReview: (reviewId: string): string => `/api/admin/reviews/${reviewId}`,
  fetchReviewList: (): string => `/api/public/reviews`,
  fetchReview: (reviewId: string): string => `/api/admin/reviews/${reviewId}`,
};
